import React, { Component, createRef } from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import * as Scroll from "react-scroll";
import history from "imports/history";
import { scrollHTo } from "imports/animate-scroll";

class TeachersSection extends Component {
    constructor(props) {
        super(props);
        this.state = {
            scrollFinished: false
        };
        this.containerRef = createRef();
        this.handleScrollEvent = this.handleScrollEvent.bind(this);
        this.handleScrollList = this.handleScrollList.bind(this);
    }

    componentDidMount() {
        this.containerRef.current.addEventListener(
            "scroll",
            this.handleScrollEvent
        );
        this.calculateScrollFinished(this.containerRef.current);
    }

    componentDidUpdate() {
        this.calculateScrollFinished(this.containerRef.current);
    }

    componentWillUnmount() {
        this.containerRef.current.removeEventListener(
            "scroll",
            this.handleScrollEvent
        );
    }

    handleScrollEvent(event) {
        const element = event.currentTarget;
        this.calculateScrollFinished(element);
    }

    calculateScrollFinished(element) {
        if (navigator.userAgent.indexOf("Firefox") === -1) {
            if (element.scrollLeft < 5 && !this.state.scrollFinished) {
                this.setState({ scrollFinished: true });
            }
            if (element.scrollLeft > 5 && this.state.scrollFinished) {
                this.setState({ scrollFinished: false });
            }
        } else {
            if (
                Math.abs(element.scrollLeft) >
                    element.scrollWidth - element.clientWidth - 10 &&
                !this.state.scrollFinished
            ) {
                this.setState({ scrollFinished: true });
            }
            if (
                Math.abs(element.scrollLeft) <
                    element.scrollWidth - element.clientWidth - 10 &&
                this.state.scrollFinished
            ) {
                this.setState({ scrollFinished: false });
            }
        }
    }

    handleScrollList() {
        const element = this.containerRef.current;
        scrollHTo(element, element.scrollLeft - 210, 600);
    }

    /** check teacher existence and insert teacher card in grid column */
    makeTeacherCards() {
        if (this.props.teachers.length === 0) {
            return (
                <div className="col-12">
                    <p>استادی در سیستم وجود ندارد.</p>
                </div>
            );
        }
        return this.props.teachers.map((teacher, index) => {
            return (
                <div
                    key={teacher.id}
                    className="col-sm-6 col-md-4 col-xs-4 teacher-col"
                >
                    <Link
                        to={`/teacher/${teacher.id}`}
                        key={index}
                        className="single-teacher"
                    >
                        <span className="img-wrapper">
                            <img src={teacher.image} alt={teacher.fullName} />
                        </span>
                        <div className="details">
                            <h4 className="name">{teacher.fullName}</h4>
                            <p className="education">{teacher.summary}</p>
                            <p className="uni">{teacher.education}</p>
                        </div>
                    </Link>
                </div>
            );
        });
    }

    render() {
        const haveScroll = !this.state.scrollFinished;
        return (
            <Scroll.Element name="mba-teachers" className="teachers">
                <div className="content">
                    <div className="top">
                        <h3 className="title">اساتید دوره</h3>
                    </div>
                    <div ref={this.containerRef} className="list">
                        {/* <div className="relative">
                            <div className="absolute">
                                <div className="carousel-sign">
                                    <i className="icon icon-dr-black-arrow-left"></i>
                                </div>
                            </div>
                        </div> */}
                        <div className="row teacher-row">
                            {this.makeTeacherCards()}
                        </div>
                    </div>
                    <div className="load-more-container">
                        <Link to={`/teachers`}>
                            <h4 className="link-to-all">
                                مشاهده تمامی اساتید
                                <i className="icon icon-dr-black-arrow-left"></i>
                            </h4>
                        </Link>
                    </div>
                    <div
                        className={
                            haveScroll
                                ? "scroll-helper"
                                : "scroll-helper hidden"
                        }
                        onClick={e => this.handleScrollList()}
                    ></div>
                    {/* <Link
                        to={`/teachers`}
                        className="btn btn--lg btn--primary--outline"
                    >
                        مشاهده همه اساتید دوره
                        <i className="icon icon-dr-black-arrow-left"></i>
                    </Link> */}
                </div>
            </Scroll.Element>
        );
    }
}

TeachersSection.propTypes = {
    teachers: PropTypes.array
};

export default TeachersSection;
